export default "__VITE_ASSET__CTWx$$Uf__"